import { createFileRoute } from "@tanstack/react-router";
import AdminNewsletterDetailPage from "@/admin/pages/newsletter-detail";

export const Route = createFileRoute("/admin/newsletters/$issueId")({
  component: AdminNewsletterDetailPage,
});
